import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import SalesMngCostStatsContainerNew from '../../containers/sales_mng_cost_stats_new/SalesMngCostStatsContainerNew';

const SalesMngCostStatsPageNew = () => {
  return (
    <div>
      <BreadcrumbsContainer
        title="예산 관리/판매관리비 등록"
        icon="budget"
      />
      <SalesMngCostStatsContainerNew />
    </div>
  );
};

export default SalesMngCostStatsPageNew;
